import { render, staticRenderFns } from "./UserGroupContainer.vue?vue&type=template&id=4709f984&scoped=true&"
import script from "./UserGroupContainer.vue?vue&type=script&lang=js&"
export * from "./UserGroupContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserGroupContainer.vue?vue&type=style&index=1&id=4709f984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4709f984",
  null
  
)

export default component.exports